export class Message {
    user: string;
    type: string;
    message: string;
    date: Date;
  }
